import { Overlay, Popover } from "react-bootstrap";
import React, { useState, useEffect, useRef } from "react";
import { HoverTooltipProps } from "./hovertooltip.props";
import "./hovertooltip.scss";

export const HoverTooltip = (props: HoverTooltipProps) => {
  const { id, help, children, placement, testid, visibilityMargin, visibilityAncestorClassname } = props;
  const [show, setShow] = useState(false);
  const [readyToShow, setReadyToShow] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const targetRef = useRef(null);

  const getTargetElement = () => {
    if (targetRef.current?.firstChild instanceof Element) {
      return targetRef.current?.firstChild;
    } else {
      return targetRef.current;
    }
  };

  useEffect(() => {
    let timer;
    if (show) {
      timer = setTimeout(() => {
        setReadyToShow(true);
      }, 150);
    } else {
      setReadyToShow(false);
    }
    return () => {
      timer && clearTimeout(timer);
    };
  }, [show]);

  useEffect(() => {
    const updateVisibility = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        setIsVisible(entry.intersectionRatio >= 0.5); // >= 0.5 means that the element is at least 50% visible
      });
    };
    const createObserver = () => {
      const observer = new IntersectionObserver(updateVisibility, {
        root: visibilityAncestorClassname ? document.querySelector(`.${visibilityAncestorClassname}`) : null,
        threshold: 0.5,
        rootMargin: visibilityMargin || "0px"
      });

      observer.observe(getTargetElement());
      return observer;
    };

    const visibilityObserver = createObserver();
    return () => {
      visibilityObserver.disconnect();
    };
  }, [visibilityAncestorClassname, visibilityMargin]);

  const handleEnter = (event) => {
    setShow(true);
  };
  const handleOut = (event) => {
    setShow(false);
  };
  const handleWheel = (event) => {
    setShow(false);
  };

  return (
    <div
      ref={targetRef}
      onMouseOver={handleEnter}
      onFocus={handleEnter}
      onMouseOut={handleOut}
      onBlur={handleOut}
      onWheel={handleWheel}
      style={{ display: "inline" }}
    >
      {children}
      <Overlay
        key={id}
        show={isVisible && show}
        target={getTargetElement()}
        placement={placement || "bottom"}
        transition={true}
      >
        <Popover
          className={`mpng-popover-info ${props.className || ""} ${readyToShow ? "ready-to-show" : ""}`}
          style={{ ...props.style }}
          {...(testid ? { "data-testid": testid } : {})}
        >
          <Popover.Body>{help}</Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
};

export default HoverTooltip;
